import React, { Fragment, PureComponent } from 'react';
import { func, string } from 'prop-types';
import { TextField, Box } from '@mui/material';
import { Button } from '../../Button';
import PasswordInput from '../../../components/PasswordInput';
import IntlMessages from '../../../util/IntlMessages';
import { AUTH_ERROR_TYPES } from '../../../constants/Values';

/**
 * Represents stateless functional component IdentifierPasswordForm
 * Asks user to enter password
 * @param {object} props Component props
 * @param {String} props.identifier Represents user login
 * @param {function} props.onFieldChange Password change callback function
 * @param {String} props.password Represents user password
 * @param {function} props.showAuthLoader Shows form loader if form is submitted
 * @param {function} props.userSignIn Dispatches an action of a specific type if form is submitted
 * @return {Component}
 * */

class IdentifierPasswordForm extends PureComponent {
  static propTypes = {
    errorMessage: string,
    identifier: string,
    handleBackClick: func,
    onFieldChange: func,
    resetErrorMessage: func,
    password: string,
    showAuthLoader: func,
    userSignIn: func,
  };

  static defaultProps = {
    errorMessage: '',
    identifier: '',
    handleBackClick: () => {},
    onFieldChange: () => {},
    password: '',
    resetErrorMessage: () => {},
    showAuthLoader: () => {},
    userSignIn: () => {},
  };

  componentWillUnmount() {
    if (this.props.errorMessage) {
      this.props.resetErrorMessage(AUTH_ERROR_TYPES.IDENTIFIER_PASS);
    }
  }

  onFormSubmit = event => {
    event.preventDefault();

    if (!this.props.password) {
      return;
    }

    this.signInUser();
  };

  handleFieldChange = event => this.props.onFieldChange(event.target.id, event.target.value);

  signInUser = () => {
    this.props.showAuthLoader();
    this.props.userSignIn();
  };

  render() {
    const { identifier, password, errorMessage, handleBackClick } = this.props;

    return (
      <Fragment>
        <Box className="app-login-header" sx={{ mb: 3 }}>
          <h2>
            <IntlMessages id="auth.enterPassword.header" />
          </h2>
        </Box>
        <div className="app-login-form">
          <form onSubmit={this.onFormSubmit}>
            <fieldset>
              <TextField
                sx={{ mt: { xs: 1, sm: 3 }, mb: { xs: 1, sm: 3 } }}
                disabled
                fullWidth
                margin="normal"
                value={identifier}
              />
              <PasswordInput
                id="password"
                defaultValue={password}
                error={!!errorMessage}
                helperText={errorMessage}
                label={<IntlMessages id="appModule.password" />}
                autoFocus
                margin="normal"
                sx={{ mt: { xs: 1, sm: 3 }, mb: { xs: 1, sm: 3 } }}
                onChange={this.handleFieldChange}
              />
              <Box sx={{ mb: 2, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <Button
                  size="large"
                  labelId="appModule.back"
                  onClick={handleBackClick}
                  variant="text"
                />
                <Button
                  size="large"
                  labelId="auth.enterPassword.buttonText"
                  color="primary"
                  disabled={!password}
                  type="submit"
                  variant="contained"
                />
              </Box>
            </fieldset>
          </form>
        </div>
      </Fragment>
    );
  }
}

export default IdentifierPasswordForm;
